<template>
  <div>
    <CrudList
      title="Discover"
      storeName="Discovers"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      canSearch
    >
      <template v-slot:category_id="{ item }">
        <div v-if="item.category_id.name">
          {{ item.category_id.name }}
        </div>

      </template>

      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center">
            <v-col
              v-for="(items, index) in item.picture"
              :key="index"
              class="d-flex child-flex"
              cols="4"
            >
              <v-list-item-avatar v-if="items.picture && items.type==='image'">
                <img
                  :src="items.picture"
                  alt=""
                  :lazy-src="items.picture"
                  aspect-ratio="1"
                  class="grey lighten-2"
                />
              </v-list-item-avatar>
            </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
